import { ButtonStyle } from '../../../settingsParams';
import stylesParams from '../../../stylesParams';

export const BUTTON_ALIGNMENT_STYLES_PARAM_BY_BUTTON_STYLE = {
  [ButtonStyle.EMPTY_CORNERED]: stylesParams.buttonEmptyCorneredAlignment,
  [ButtonStyle.EMPTY_ROUNDED]: stylesParams.buttonEmptyRoundedAlignment,
  [ButtonStyle.FULL_ROUNDED]: stylesParams.buttonFullRoundedAlignment,
  [ButtonStyle.FULL_CORNERED]: stylesParams.buttonFullCorneredAlignment,
};
